<template>
  <iframe width="100%" height="100%" :src="uri"></iframe>
</template>

<script>
// test
//import ComponentInWorker from "@/components/ComponentInWorker";
export default {
  data() {
    return {
      uri: "https://apicloud.magycorp.com:48028/docs/mview/FLYER%20MVIEW.pdf"
    };
  }
};
</script>

<style></style>
